import React from 'react';
import aboutMain from '@/assets/kite2.jpeg';
import PageBanner from '@/components/ui/PageBanner';
import BodyMotion from '@/components/ui/BodyMotion';
import { motion } from 'framer-motion';
import ContactForm from '@/components/sections/ContactForm';
import '@/pages/Extras.scss';
import useHashScroll from '@/hooks/useHashScroll';
import useActiveSection from '@/hooks/useActiveSection';

const Principals: React.FC = () => {
  useHashScroll();
  const sectionIds = React.useMemo(() => ['contact'], []);
  useActiveSection(sectionIds);
  
  return (
    <main className="extra-page">
      <PageBanner title="Principals" image={aboutMain} />
      <section className="extra-page__content container">
        <BodyMotion>
          <h5 className="extra-page__accent">
            Our principals have deep real estate, hospitality & aviation experience.
          </h5>
          <h5 className="extra-page__team-name">Gordon Chase</h5>
          <p>
            Gordon has invested in and managed a private portfolio of international real estate since 2006, accumulating prime assets across Amsterdam, Lisbon, Dublin and Manchester. Ephemera Partners is the corporate expression of that long-running private investment practice.
          </p>
          <p>
            A corporate lawyer practising for over 20 years, he enjoys executing on the opportunities presented by leveraged investing across diverse legal, tax and regulatory environments.
          </p>
          <p>
            Gordon’s passion for aviation finance is inspired by the exceptionally talented people who populate this most international of industries. For nearly two decades he worked alongside colleagues of remarkable caliber as Head of Corporate Legal at AerCap (NYSE: AER), the industry leader with a fleet of more than 3,000 aircraft, engines and helicopters. During his time at AerCap, Gordon participated in every significant corporate transaction by which the balance sheet scaled from $4bn at IPO in 2006 to over $70bn, including the largest M&A and finance transactions in industry history.
          </p>
          <p>
            Since leaving AerCap in 2025, Gordon has focused on developing AI-native software applications across international real estate asset management, hospitality, and legal practice.
          </p>
          <h5 className="extra-page__team-name">Renata Thamires Dos Santos Costa</h5>
          <p>
            Renata combines an intuitive approach to human connection, grounded in extensive
            experience in the medical profession, with a passion for creating exceptional guest
            experiences. Her approach is underpinned by training from Cornell’s Nolan School of
            Hotel Administration, the industry’s benchmark for excellence in hospitality and service
            leadership, as well as extensive experience of the demanding service standards in
            international five-star hotels. She has hosted countless guests across multiple
            jurisdictions and consistently receives excellent feedback for the curated premium
            experience she delivers.
          </p>
        </BodyMotion>
      </section>
      <section id="contact">
        <motion.div
          className="contactFormLayout"
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: [0.25, 0.1, 0.25, 1] }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <ContactForm />
        </motion.div>
      </section>
    </main>
  );
};

export default Principals;
